













import {
  defineComponent,
  inject,
  ref,
  onBeforeMount,
  watch,
} from '@vue/composition-api'
import { alertsSymbol, getUserSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import AlertContainer from '@/components/custom/AlertContainer.vue'
export default defineComponent({
  name: 'DashboardIndex',
  components: {
    AlertContainer,
    DashboardCoreAppBar: () => import('./components/core/AppBar.vue'),
    DashboardCoreDrawer: () => import('./components/core/Drawer.vue'),
    // DashboardCoreSettings: () => import('./components/core/Settings'),
    DashboardCoreView: () => import('./components/core/View.vue'),
  },
  setup(props, { root }) {
    const expandOnHover = ref(false)
    const userLoaded = ref(false)
    const alerts = inject(alertsSymbol)
    const getUser = inject(getUserSymbol) as Function
    const { actions, getters } = useTextbookStore()
    const { textbooks, loading } = getters
    const { updateActiveTextbook, updateActiveTextbookIssue } = actions

    const updateActiveTextbookAndIssue = (
      textbookId: string,
      textbookIssueId: string
    ) => {
      updateActiveTextbook(textbookId)
      updateActiveTextbookIssue(textbookIssueId)
    }
    watch(
      () => root.$route.params,
      (newVal) => {
        updateActiveTextbookAndIssue(newVal.textbookId, newVal.textbookIssueId)
      }
    )

    watch(
      () => loading.value,
      () => {
        updateActiveTextbookAndIssue(
          root.$route.params.textbookId,
          root.$route.params.textbookIssueId
        )
      }
    )

    onBeforeMount(async () => {
      await getUser()
      userLoaded.value = true
    })

    return {
      expandOnHover,
      alerts,
      textbooks,
      userLoaded,
    }
  },
})
